import {Dispatch} from "redux";
import {ModalVisibilityPayload} from "../../models/custom/modalVisibility.payload";
import {SET_MODAL_VISIBILITY} from "./constants";
import {SetModalVisibilityAction} from "./types";

export const setModalVisibilityAction = (payload: ModalVisibilityPayload): SetModalVisibilityAction => {
  return {
    type: SET_MODAL_VISIBILITY,
    payload: payload,
  };
}

export const setModalVisibility = (payload: ModalVisibilityPayload) => async (
  dispatch: Dispatch
) => {
  dispatch(setModalVisibilityAction(payload));
};
